import {useCallback} from "react"
import {useQuery, useQueryClient} from "@tanstack/react-query"
import {documentTemplatesService} from "services"
import {UNLIMITED_PAGE_SIZE} from "data/constants"

const queryCacheKey = "all-document-templates"
const INITIAL_DATA = []

type Props = {
    enabled?: boolean
}

export const useAllDocumentTemplates = (props: Props) => {
    const {enabled = true} = props
    const queryClient = useQueryClient()

    const query = useQuery(
        [queryCacheKey],
        async () => {
            const {data} = await documentTemplatesService.getAll({
                range: {
                    page: 1,
                    pageSize: UNLIMITED_PAGE_SIZE
                }
            })
            return data
        },
        {
            enabled,
            refetchOnMount: false
        }
    )

    return {
        templates: query.data ?? INITIAL_DATA,
        invalidateDocumentTemplatesCache: useCallback(() => {
            queryClient.invalidateQueries({queryKey: [queryCacheKey]})
        }, [queryClient])
    }
}
